export const color = {
	brandPrimary: 'rgb(224, 30, 30)',
	redA400: '#FF1744',
	textDarkPrimary: '#353535',
	textDarkSecondary: '#757575',
	dividerDark: 'rgba(0, 0, 0, 0.12)',
	blackHaze: '#F7F7F7'
};
